/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const saleService = {
  getList: (params: any) => request.get('/sale', { params }),
  getSaleById: (id: any) => request.get(`/sale/${id}`),
  createSale: (data: any) => request.post('/sale', data),
  deleteSale: (id: any) => request.delete(`/sale/${id}`),
  updateSale: (id: any, data: any) => request.put(`/sale/${id}`, data)
};

export default saleService;
